import { getCollections } from "@/services/transactions.service";
import { useQuery } from "@tanstack/react-query";

export const useCollectionStats = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "collections",
    params.page,
    params.size,
    params.status,
    params.channel,
    params.merchantId,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getCollections(params),
    enabled,
    ...options,
  });
};
